import styled from "styled-components";
// hooks
import { Dispatch, SetStateAction, useEffect, useState } from "react";
// utils
import { add, format } from "date-fns";
// context
import { useAdmin } from "../../../context/admin";
// icons
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// components
import CalendarDual from "../../common/CalendarDual";
// mobile
import { mobile } from "../../../styles/responsive";

type FilterProps = {
    filter?: 'authorized' | 'rejected' | 'pending' | undefined;
    setFilter: Dispatch<SetStateAction<'authorized' | 'rejected' | 'pending' | undefined>>;
}

const filterItems = [
    {
        label: 'Aprobados',
        value: 'authorized'
    },
    {
        label: 'Rechazados',
        value: 'rejected'
    },
    {
        label: 'Pendientes',
        value: 'pending'
    }
]

export default function Filter({
    filter,
    setFilter
}: FilterProps) {
    const { currentDay, setCurrentDay, endDay, setEndDay } = useAdmin()
    const [isCalendarOpen, setIsCalendarOpen] = useState(false)

    function handleCurrentDay (action: 'forwards' | 'backwards') {
        const newDate = add(currentDay, {days: action === 'backwards' ? -1 : 1} )
        setCurrentDay(newDate)
    }

    function handleFilterChange (filterValue: 'authorized' | 'rejected' | 'pending' | undefined) {
        setFilter(filterValue)
    }
    
    return (
        <Main>
            <button
                onClick={() => handleCurrentDay('backwards')}
                >
                    <IoIosArrowBack/>
                </button>
                <div className="filters">
                    <div className="date"
                    >
                        <button className="open-calendar"
                        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                        ></button>
                        {
                            currentDay && <span 
                            >{`${format(currentDay, 'dd/MM/yyyy')} ${endDay ? '- ' + format(endDay, 'dd/MM/YYY'): ''}`}</span>
                        }
                        <div className={`calendar ${isCalendarOpen ? 'open' : ''}`}>
                            <CalendarDual
                            endDay={endDay}
                            setEndDay={setEndDay}
                            selectedDay={currentDay}
                            setSelectedDay={setCurrentDay}
                            selectPastDays
                            />
                        </div>
                    </div>
                    {
                        <div className="dropdown">
                            <select
                            value={filter}
                            onChange={(e) => handleFilterChange(e.target.value as 'authorized' | 'rejected' | 'pending' | undefined)}>
                                <option disabled selected>-</option>
                                {
                                    filterItems.map(item => (
                                        <option key={item.value} value={item.value}>{item.label}</option>
                                    ))
                                }
                            </select>
                        </div>
                    }
                </div>
                <button
                onClick={() => handleCurrentDay('forwards')}
                >
                    <IoIosArrowForward/>
                </button>
        </Main>
    )
}

const Main = styled.div`
width: 100%;
padding: 30px 0;
display: flex;
justify-content: space-around;
.filters {
    flex: 1;
    display: flex;
    justify-content: center;
    gap: 10px;
    ${mobile({
        flexDirection: 'column',
        alignItems: 'center'
    })}
}
.filters > .dropdown {
    height: 100%;
    select {
        height: 100%;
        padding: 5px 10px;
    }
}
.filters > .date {
    padding: 20px;
    width: 70%;
    max-width: 350px;
    text-align: center;
    height: 100%;
    position: relative;
    z-index: 10;
    > button.open-calendar {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background-color: ${props => props.theme.blueLight};
        cursor: pointer;
        border: none;
    }
    > .calendar {
        display: none;
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        &.open {
            display: initial;
        }
    }
    > span {
        color: #FFF;
        position: absolute;
        white-space: nowrap;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
    }
}
> button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 30px;
    border: none;
    background-color: ${props => props.theme.white};
    font-size: 16px;
    color: #000;
    box-shadow: 0 5px 3px ${props => props.theme.blackTransparent};
    transition: transform .3s ease;
    cursor: pointer;
    &:hover {
        transform: translateY(-3px);
    }
}
`